import React from 'react';
import { PageLayout, PageLayoutTitle, Table, TableHeader, TableRow, TableHeaderCell, TableBody, CellButton, TableBodyCell, Button, PageLayoutContentLoading, PageLayoutContentError, PageLayoutContentEmpty, PageLayoutContent, PageLayoutContentTitle, PageLayoutContentDescribe } from '@tolk-ai/ui-library-react';
import * as customerApi from '@tolk-ai/connectors-config-customer-api';
import * as genericUtils from '@tolk-ai/generic-utils';

const convertCustomerApisToCustomerApisToDisplay = customerApis => {
  const customerApisToDisplay = customerApis.map(customerApi => {
    return {
      id: customerApi.id,
      name: customerApi.name
    };
  });
  return customerApisToDisplay;
};

const init = async (botId, getManyCustomerApi, setState) => {
  try {
    setState({
      type: 'loading'
    });
    const result = await getManyCustomerApi(botId);

    if (genericUtils.isDomainError(result, customerApi.appPorts.GetManyCustomerApiErrors)) {
      switch (result) {
        case customerApi.appPorts.GetManyCustomerApiErrors.inexistingBot:
        default:
          setState({
            message: 'An error occured, please retry',
            type: 'error'
          });
          return;
      }
    }

    if (genericUtils.isEmpty(result)) {
      setState({
        type: 'empty'
      });
      return;
    }

    setState({
      customerApis: convertCustomerApisToCustomerApisToDisplay(result),
      type: 'default'
    });
    return;
  } catch (_a) {
    setState({
      message: 'An error occured, please retry',
      type: 'error'
    });
  }
};

const onInit = async (botId, getManyCustomerApi, setState) => {
  await init(botId, getManyCustomerApi, setState);
};

const onRetryButtonClick = (botId, getManyCustomerApi, setState) => async () => {
  await init(botId, getManyCustomerApi, setState);
};

const onEditApiButtonClick = history => event => history.push('/customer-apis/setup', {
  customerApiId: event.currentTarget.value
});

const onCreateButtonClick = history => () => history.push('/customer-apis/setup');

var styles$2 = {"apis__container":"index-module_apis__container__DC3Wh"};

const Apis = ({
  botId,
  getManyCustomerApi,
  history
}) => /*#__PURE__*/React.createElement(PageLayout, null, /*#__PURE__*/React.createElement(PageLayoutTitle, null, "APIs"), /*#__PURE__*/React.createElement("div", {
  className: styles$2.apis__container
}, /*#__PURE__*/React.createElement(CustomerApi, {
  botId: botId,
  getManyCustomerApi: getManyCustomerApi,
  history: history,
  onCreateButtonClick: onCreateButtonClick(history)
})));

var styles$1 = {"table__cell":"index-module_table__cell__4Ca0L"};

const CustomerApiTable = ({
  customerApis,
  onClickEditApiButton
}) => {
  return /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHeader, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableHeaderCell, {
    description: "Name of the related APIs"
  }, "Available APIs"), /*#__PURE__*/React.createElement(TableHeaderCell, {
    description: "Column with pen icon button to edit an existing API"
  }))), /*#__PURE__*/React.createElement(TableBody, null, customerApis.map(customerApi => {
    return /*#__PURE__*/React.createElement(TableRow, {
      key: customerApi.id
    }, /*#__PURE__*/React.createElement(CellButton, {
      onClick: onClickEditApiButton,
      value: customerApi.id
    }, customerApi.name), /*#__PURE__*/React.createElement(TableBodyCell, {
      className: styles$1.table__cell
    }, /*#__PURE__*/React.createElement(Button, {
      icon: {
        border: 'none',
        name: 'PencilIcon',
        screenReaderDescribe: `Edit button to redirect to the customer api with name ${customerApi.name}`
      },
      isOutlined: true,
      onClick: onClickEditApiButton,
      value: customerApi.id
    })));
  })));
};

const CustomerApiTableViewer = ({
  botId,
  getManyCustomerApi,
  history
}) => {
  const [state, setState] = React.useState({
    type: 'loading'
  });
  React.useEffect(() => {
    void onInit(botId, getManyCustomerApi, setState);
  }, [botId, getManyCustomerApi]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, state.type === 'loading' && /*#__PURE__*/React.createElement(PageLayoutContentLoading, null), state.type === 'error' && /*#__PURE__*/React.createElement(PageLayoutContentError, {
    buttonText: "Retry",
    message: state.message,
    onButtonClick: onRetryButtonClick(botId, getManyCustomerApi, setState)
  }), state.type === 'empty' && /*#__PURE__*/React.createElement(PageLayoutContentEmpty, null, "No existing customer APIs was found."), state.type === 'default' && /*#__PURE__*/React.createElement(CustomerApiTable, {
    customerApis: state.customerApis,
    onClickEditApiButton: onEditApiButtonClick(history)
  }));
};

var styles = {"customer-api":"index-module_customer-api__ehrv2","customer-apis__header":"index-module_customer-apis__header__VVMbR"};

const CustomerApi = ({
  botId,
  onCreateButtonClick,
  getManyCustomerApi,
  history
}) => {
  return /*#__PURE__*/React.createElement(PageLayoutContent, {
    className: styles['customer-api']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['customer-apis__header']
  }, /*#__PURE__*/React.createElement(PageLayoutContentTitle, null, "custom apis"), /*#__PURE__*/React.createElement(Button, {
    onClick: onCreateButtonClick
  }, "Setup an API")), /*#__PURE__*/React.createElement(PageLayoutContentDescribe, null, "Manage your custom APIs."), /*#__PURE__*/React.createElement(CustomerApiTableViewer, {
    botId: botId,
    getManyCustomerApi: getManyCustomerApi,
    history: history
  }));
};

const component = (history, getManyCustomerApi) => ({
  botId
}) => /*#__PURE__*/React.createElement(Apis, {
  botId: botId,
  getManyCustomerApi: getManyCustomerApi,
  history: history
});

export { component };
